export const DEFAULT = 'default';
export const AUTUMN = 'autumn';
export const NIGHT = 'night';
export const NEON = 'neon';
export const DARK = 'dark';

export type types = typeof DEFAULT | typeof AUTUMN | typeof NIGHT | typeof NEON | typeof DARK;
